import styled from "styled-components";

export const Svg = styled.svg`
  stroke: dimgray;
  stroke-width: 2;
  fill: none;
  height: 100%;
`;

export const GapSvg = styled(Svg)`
  position: absolute;
  width: 100%;
`;
